/**
 * 配菜算法注册表。
 *
 * 后期更换组合算法：
 * 1. 在本目录新增文件，导出 selectDishes(dishes, context)
 * 2. 在 ALGORITHMS 中注册
 * 3. 把 CURRENT_ALGORITHM 改成新 key
 */
import { selectDishes as greedyByProfit } from './greedyByProfit'
import { selectDishes as categoryCombo } from './categoryCombo'

export const ALGORITHMS = {
  categoryCombo,
  greedyByProfit
}

/** 当前使用的组合算法 */
export const CURRENT_ALGORITHM = 'categoryCombo'

export function getCurrentSelector() {
  const fn = ALGORITHMS[CURRENT_ALGORITHM]
  if (typeof fn !== 'function') {
    throw new Error(`未找到配菜算法：${CURRENT_ALGORITHM}`)
  }
  return fn
}
